// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/succes-circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Screen.Import .Content {
  height: calc(100% - 108px);
}
.Screen.Import .Content .ImportDragTarget {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  margin-top: 38px;
  margin-bottom: 20px;
  padding-top: 87px;
  padding-bottom: 0;
  position: relative;
  width: 650px;
  left: 50%;
  margin-left: -325px;
  background: #F5F6F9;
  border: 2px #D3D6DF dashed;
}
.Screen.Import .Content .ImportDragTarget h5 {
  margin-bottom: 72px;
  margin-top: 29px;
}
.Screen.Import .Content .ImportDragTarget p.Error {
  position: absolute;
  font-size: 14px;
  color: #D92D20;
  line-height: 24px;
  width: 100%;
  bottom: 26px;
  text-align: center;
}
.Screen.Import .Content .ImportDragTarget.Active {
  border-color: #002E33;
  background-color: #F5F6F9;
}
.Screen.Import .Content .ImportDragTarget.Error {
  background-color: #FFF8F6;
}
.Screen.Import .Content .ImportDragTarget.Picked {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center 61px no-repeat #F5F6F9;
  padding-bottom: 34px;
}
.Screen.Import .Content .ImportDragTarget.Picked h5 {
  padding-top: 10px;
  margin-bottom: 60px;
}
.Screen.Import .Content .ImportDragTarget.Picked a {
  display: inline-block;
  margin: 0 auto;
  font-size: 14px;
  cursor: pointer;
}
.Screen.Import .Content .ImportDragTarget label {
  margin: 0 auto;
  display: inline-block;
}
.Screen.Import .Content .ImportDragTarget label div.Button {
  padding-right: 40px;
  padding-left: 20px;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/Screen/ImportScreen/ImportScreen.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGE;EACE,0BAAA;AAFJ;AAII;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,mBCwCG;EDvCH,0BAAA;AAFN;AAIM;EACE,mBAAA;EACA,gBAAA;AAFR;AAKM;EACE,kBAAA;EACA,eAAA;EACA,cClBF;EDmBE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAHR;AAMM;EACE,qBCnCO;EDoCP,yBCoBC;ADxBT;AAOM;EACE,yBCOD;ADZP;AAQM;EACE,iFAAA;EACA,oBAAA;AANR;AAQQ;EACE,iBAAA;EACA,mBAAA;AANV;AASQ;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAPV;AAYM;EACE,cAAA;EACA,qBAAA;AAVR;AAYQ;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;AAVV","sourcesContent":["@import \"src/client/Global/Colors\";\n\n.Screen.Import {\n  .Content {\n    height: calc(100% - 108px);\n\n    .ImportDragTarget {\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n      margin-top: 38px;\n      margin-bottom: 20px;\n      padding-top: 87px;\n      padding-bottom: 0;\n      position: relative;\n      width: 650px;\n      left: 50%;\n      margin-left: -325px;\n      background: $Gray20;\n      border: 2px $Gray50 dashed;\n\n      h5 {\n        margin-bottom: 72px;\n        margin-top: 29px;\n      }\n\n      p.Error {\n        position: absolute;\n        font-size: 14px;\n        color: $Red;\n        line-height: 24px;\n        width: 100%;\n        bottom: 26px;\n        text-align: center;\n      }\n\n      &.Active {\n        border-color: $DeepSeaGreen;\n        background-color: $Gray20;\n      }\n\n      &.Error {\n        background-color: $Red5;\n      }\n\n      &.Picked {\n        background: url(\"~images/succes-circle.svg\") center 61px no-repeat $Gray20;\n        padding-bottom: 34px;\n\n        h5 {\n          padding-top: 10px;\n          margin-bottom: 60px;\n        }\n\n        a {\n          display: inline-block;\n          margin: 0 auto;\n          font-size: 14px;\n          cursor: pointer;\n        }\n\n      }\n\n      label {\n        margin: 0 auto;\n        display: inline-block;\n\n        div.Button {\n          padding-right: 40px;\n          padding-left: 20px;\n          border-radius: 4px;\n        }\n      }\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
